import {DataSet} from '../models/dataset';

export const DATASET_MTCAR_SYN: DataSet = {
  name: 'mtcar',
  fields: ['Variable_1', 'Variable_2', 'Correlation_1', 'Correlation_2'],
  rawData: [
    {"Variable_1": "mpg", "Variable_2": "mpg", "Correlation_1": null, "Correlation_2": null},

    {"Variable_1": "mpg", "Variable_2": "cyl", "Correlation_1": 0.85, "Correlation_2": 0.9},
    {"Variable_1": "mpg", "Variable_2": "dlsp", "Correlation_1": 0.85, "Correlation_2": 0.85},
    {"Variable_1": "cyl", "Variable_2": "dlsp", "Correlation_1": 0.2, "Correlation_2": 0.92},
    {"Variable_1": "mpg", "Variable_2": "hp", "Correlation_1": 0.78, "Correlation_2": 0.2},
    {"Variable_1": "cyl", "Variable_2": "hp", "Correlation_1": 0.83, "Correlation_2": 0.84},
    {"Variable_1": "dlsp", "Variable_2": "hp", "Correlation_1": 0.79, "Correlation_2": 0.80},
    {"Variable_1": "mpg", "Variable_2": "drat", "Correlation_1": 0.68, "Correlation_2": 0.82},
    {"Variable_1": "cyl", "Variable_2": "drat", "Correlation_1": 0.7, "Correlation_2": 0.6},
    {"Variable_1": "dlsp", "Variable_2": "drat", "Correlation_1": 0.71, "Correlation_2": 0.9},
    {"Variable_1": "hp", "Variable_2": "drat", "Correlation_1": 0.45, "Correlation_2": 0.3},
    {"Variable_1": "mpg", "Variable_2": "wt", "Correlation_1": 0.87, "Correlation_2": 0.2},
    {"Variable_1": "cyl", "Variable_2": "wt", "Correlation_1": 0.78, "Correlation_2": 0.78},
    {"Variable_1": "dlsp", "Variable_2": "wt", "Correlation_1": 0.89, "Correlation_2": 0.79},
    {"Variable_1": "hp", "Variable_2": "wt", "Correlation_1": 0.66, "Correlation_2": 0.65},
    {"Variable_1": "drat", "Variable_2": "wt", "Correlation_1": 0.71, "Correlation_2": 0.79},
    {"Variable_1": "mpg", "Variable_2": "qsec", "Correlation_1": 0.42, "Correlation_2": 0.43},
    {"Variable_1": "cyl", "Variable_2": "qsec", "Correlation_1": 0.59, "Correlation_2": 0.65},
    {"Variable_1": "dlsp", "Variable_2": "qsec", "Correlation_1": 0.43, "Correlation_2": 0.2},
    {"Variable_1": "hp", "Variable_2": "qsec", "Correlation_1": 0.71, "Correlation_2": 0.5},
    {"Variable_1": "drat", "Variable_2": "qsec", "Correlation_1": 0.09, "Correlation_2": 0.14},
    {"Variable_1": "wt", "Variable_2": "qsec", "Correlation_1": 0.17, "Correlation_2": 0.23},
    {"Variable_1": "mpg", "Variable_2": "vs", "Correlation_1": 0.66, "Correlation_2": 0.53},
    {"Variable_1": "cyl", "Variable_2": "vs", "Correlation_1": 0.81, "Correlation_2": 0.28},
    {"Variable_1": "dlsp", "Variable_2": "vs", "Correlation_1": 0.71, "Correlation_2": 0.79},
    {"Variable_1": "hp", "Variable_2": "vs", "Correlation_1": 0.72, "Correlation_2": 0.72},
    {"Variable_1": "drat", "Variable_2": "vs", "Correlation_1": 0.44, "Correlation_2": 0.72},
    {"Variable_1": "wt", "Variable_2": "vs", "Correlation_1": 0.55, "Correlation_2": 0.3},
    {"Variable_1": "qsec", "Variable_2": "vs", "Correlation_1": 0.74, "Correlation_2": 0.44},
    //
    {"Variable_2": "mpg", "Variable_1": "cyl", "Correlation_1": 0.85, "Correlation_2": 0.9},
    {"Variable_2": "mpg", "Variable_1": "dlsp", "Correlation_1": 0.85, "Correlation_2": 0.85},
    {"Variable_2": "cyl", "Variable_1": "dlsp", "Correlation_1": 0.2, "Correlation_2": 0.92},
    {"Variable_2": "mpg", "Variable_1": "hp", "Correlation_1": 0.78, "Correlation_2": 0.2},
    {"Variable_2": "cyl", "Variable_1": "hp", "Correlation_1": 0.83, "Correlation_2": 0.84},
    {"Variable_2": "dlsp", "Variable_1": "hp", "Correlation_1": 0.79, "Correlation_2": 0.80},
    {"Variable_2": "mpg", "Variable_1": "drat", "Correlation_1": 0.68, "Correlation_2": 0.82},
    {"Variable_2": "cyl", "Variable_1": "drat", "Correlation_1": 0.7, "Correlation_2": 0.6},
    {"Variable_2": "dlsp", "Variable_1": "drat", "Correlation_1": 0.71, "Correlation_2": 0.9},
    {"Variable_2": "hp", "Variable_1": "drat", "Correlation_1": 0.45, "Correlation_2": 0.3},
    {"Variable_2": "mpg", "Variable_1": "wt", "Correlation_1": 0.87, "Correlation_2": 0.2},
    {"Variable_2": "cyl", "Variable_1": "wt", "Correlation_1": 0.78, "Correlation_2": 0.78},
    {"Variable_2": "dlsp", "Variable_1": "wt", "Correlation_1": 0.89, "Correlation_2": 0.79},
    {"Variable_2": "hp", "Variable_1": "wt", "Correlation_1": 0.66, "Correlation_2": 0.65},
    {"Variable_2": "drat", "Variable_1": "wt", "Correlation_1": 0.71, "Correlation_2": 0.79},
    {"Variable_2": "mpg", "Variable_1": "qsec", "Correlation_1": 0.42, "Correlation_2": 0.43},
    {"Variable_2": "cyl", "Variable_1": "qsec", "Correlation_1": 0.59, "Correlation_2": 0.65},
    {"Variable_2": "dlsp", "Variable_1": "qsec", "Correlation_1": 0.43, "Correlation_2": 0.2},
    {"Variable_2": "hp", "Variable_1": "qsec", "Correlation_1": 0.71, "Correlation_2": 0.5},
    {"Variable_2": "drat", "Variable_1": "qsec", "Correlation_1": 0.09, "Correlation_2": 0.14},
    {"Variable_2": "wt", "Variable_1": "qsec", "Correlation_1": 0.17, "Correlation_2": 0.23},
    {"Variable_2": "mpg", "Variable_1": "vs", "Correlation_1": 0.66, "Correlation_2": 0.53},
    {"Variable_2": "cyl", "Variable_1": "vs", "Correlation_1": 0.81, "Correlation_2": 0.28},
    {"Variable_2": "dlsp", "Variable_1": "vs", "Correlation_1": 0.71, "Correlation_2": 0.79},
    {"Variable_2": "hp", "Variable_1": "vs", "Correlation_1": 0.72, "Correlation_2": 0.72},
    {"Variable_2": "drat", "Variable_1": "vs", "Correlation_1": 0.44, "Correlation_2": 0.72},
    {"Variable_2": "wt", "Variable_1": "vs", "Correlation_1": 0.55, "Correlation_2": 0.3},
    {"Variable_2": "qsec", "Variable_1": "vs", "Correlation_1": 0.74, "Correlation_2": 0.44},
  ]
}


// WEBPACK FOOTER //
// ./src/datasets/mtcar_syn.ts